import ViewAllQuestionsMobileView from "../Components/ViewAllQuestionsMobileView";
import { ViewAllQuestionsMobileViewPropsType } from "../ViewAllQuestionsMobileViewPropsType";

export default function ViewAllQuestionsMobileViewContainer({
  reducerState,
  questionObjVariable,
  handleQuestionsToRender,
  surveyAnswers,
}: ViewAllQuestionsMobileViewPropsType) {
  return (
    <ViewAllQuestionsMobileView
      reducerState={reducerState}
      questionObjVariable={questionObjVariable}
      handleQuestionsToRender={handleQuestionsToRender}
      surveyAnswers={surveyAnswers}
    />
  );
}
